import esearch from './client';
const opts = {
    headers: {
        Accept: 'application/vnd.sncr.esearch-1.1+json',
        'Content-Type': 'application/vnd.sncr.esearch-1.0+json',
    },
};
const apiType = 'esearch';
export const eSearchGet = async (endpoint, headers, logger) => {
    logger ? esearch.setLogger(logger) : undefined;
    return esearch.get(`/user/{userId}/${endpoint}`, apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
